/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, FormMode } from '@gh/core-ui';
import { LeadDetailsBusinessService } from '../../../';
import { SfCompletionAuthorization } from '../../../resources/lead.model';

@Component({
  standalone: false,
  selector: 'gh-complete-sale-authorization-step',
  templateUrl: 'complete-sale-authorization-step.component.html',
})
export class CompleteSaleAuthorizationStepComponent
  extends AbstractSnapshotFormComponent<SfCompletionAuthorization>
  implements OnInit {
    unitsCountList: number[] = [];
    countOfUnit = 15;
  constructor(private formStateBuilder: FormStateBuilder,
              private business: LeadDetailsBusinessService) {
    super();
    for (let i = 0; i < this.countOfUnit; i++) {
      this.unitsCountList.push(i + 1);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    const unitsCountControl = this.form?.group?.get('unitsCount');
    if (unitsCountControl && !unitsCountControl.value) unitsCountControl.setValue(1);
  }

  loadBaseDesigns(event: AutocompleteLoadMoreEvent): void {
    event.load(this.business.findAllBaseDesignsByName(event.query));
  }

  protected buildForm(snapshot: FormStateSnapshot<SfCompletionAuthorization>): FormState<SfCompletionAuthorization> {
    return this.formStateBuilder.buildPlain({
      snapshot,
      mode: FormMode.EditMode,
      children: {
        code: { enabled: false },
        description: void 0,
        baseDesign: { required: true },
        contractPrice: { enabled: false },
        unitsCount: { required: true },
        memo: void 0,
      },
    });
  }
}
